import React from 'react';

import {
  BADGE_COLOR_MAP,
  MASTERY_LEVEL_GRAPH_MAPPER,
  STUDENT_GOAL_STATUSES
} from 'constants/studentGoals';
import { capitalize } from 'utils';

import { SIGNIFICANT_ERRORS_IN_WORK } from 'pages/Teachers/Insights/constants';
import { ReactComponent as CheckedIcon } from 'pages/Teachers/StudentDetail/assets/checked.svg';
import { ReactComponent as CloseIcon } from 'pages/Teachers/StudentDetail/assets/close.svg';
import { ReactComponent as UncheckedIcon } from 'pages/Teachers/StudentDetail/assets/unchecked.svg';

import styles from './styles.module.scss';

const StatusUpdateModal = ({ point, hasGoal, onClose, onUpdateStatus }) => {
  const isSuccessful = point.status === STUDENT_GOAL_STATUSES.SUCCESSFUL;
  const showDownwards =
    point.y >
    MASTERY_LEVEL_GRAPH_MAPPER[SIGNIFICANT_ERRORS_IN_WORK].graphicYValue;

  const popupStyle = showDownwards
    ? { left: `${point.x}%`, top: `${100 - point.y}%` }
    : { left: `${point.x}%`, bottom: `${point.y}%` };

  let horizontalAlignment = styles.alignCenter;
  if (point.x > 85) {
    horizontalAlignment = styles.alignRight;
  } else if (point.x < 15) {
    horizontalAlignment = styles.alignLeft;
  }

  const badgeStyle = BADGE_COLOR_MAP[point.statusLabel] || {};

  return (
    <div
      className={`${styles.popupContainer} ${
        showDownwards ? styles.layerDownwards : styles.layerUpwards
      } ${horizontalAlignment}`}
      style={popupStyle}
    >
      <div className={styles.header}>
        <span className={styles.badge} style={badgeStyle}>
          {point.statusLabel}
        </span>
        <span className={styles.date}>{point.dateLabel}</span>
        <button onClick={onClose} className={styles.closeBtn}>
          <CloseIcon />
        </button>
      </div>

      {hasGoal && (
        <div className={styles.toggleSection}>
          <span className={styles.trialLabel}>Trial:</span>
          <label className={styles.switch}>
            <input
              type="checkbox"
              checked={isSuccessful}
              onChange={() =>
                onUpdateStatus({
                  newStatus: isSuccessful
                    ? STUDENT_GOAL_STATUSES.UNSUCCESSFUL
                    : STUDENT_GOAL_STATUSES.SUCCESSFUL
                })
              }
            />
            <span className={styles.slider}>
              <span className={styles.thumb}>
                {isSuccessful ? <CheckedIcon /> : <UncheckedIcon />}
              </span>
            </span>
          </label>
          <span className={styles.statusText}>
            {isSuccessful
              ? capitalize({ str: STUDENT_GOAL_STATUSES.SUCCESSFUL })
              : capitalize({ str: STUDENT_GOAL_STATUSES.UNSUCCESSFUL })}
          </span>
        </div>
      )}
    </div>
  );
};

export default StatusUpdateModal;
